import {Component, Input, OnInit} from '@angular/core';
import {IconDefinition} from '@fortawesome/fontawesome-common-types';
import {
  faAngleDoubleRight, faBan, faCheckCircle,
  faCircleNotch,
  faClock,
  faFaucet,
  faFile, faMedkit, faNotEqual, faPauseCircle,
  faPercent, faPlay, faPlusCircle, faPowerOff, faRunning, faSun,
  faThermometerHalf, faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import {faCloudscale, faFacebook} from "@fortawesome/free-brands-svg-icons";

@Component({
  selector: 'app-status-symbol',
  templateUrl: './status-symbol.component.html',
  styleUrls: ['./status-symbol.component.css']
})
export class StatusSymbolComponent implements OnInit {

  @Input()
  value: number = 0;
  icon: IconDefinition = faFile;

  constructor() {
  }

  ngOnInit(): void {
    this.icon = this.Transfrom(this.value);
  }

  Transfrom(value: number): IconDefinition
  {
    switch (this.value) {
      case 0:        return faFaucet;
      case 1:        return faClock;



      case 272:        return faPowerOff;
      case 273:        return this.icon = faPlay;

      case 276:        return faPowerOff;
      case 277:        return faPlusCircle;



      // Status behandeling Akkerbouw
      case 97 :  return  faPowerOff; // - Uit   -
      case 98 :  return  faCheckCircle; // - Standby
      case 99 :  return  faNotEqual; // - Wil   -
      case 100:  return  faRunning; //  - Actief
      case 101:  return  faPauseCircle; //  - Wacht
      case 102:  return  faBan; //  - Blok
      case 103:  return  faTimesCircle; //  - Error

        // Klok status algemeen
      case 457:  return    faPowerOff; //  - Uit
      case 458:  return    faCloudscale; //  - Actief



      default:
        return faFacebook;
      }
    }
}
